const cameraOffMarkerSides = {
  top: 'top',
  right: 'right',
  bottom: 'bottom',
  left: 'left',
};

const cameraOffPlaceholderSize = {
  width: 1920,
  height: 720,
};

const cameraOffMarkerSize = {
  width: 192,
  height: 96,
};

const cameraOffMarkers = [
  {
    id: 'top-left',
    xSide: cameraOffMarkerSides.left,
    ySide: cameraOffMarkerSides.top,
    color: '#ff00ff',
    rgb: { r: 255, g: 0, b: 255 },
  },
  {
    id: 'top-right',
    xSide: cameraOffMarkerSides.right,
    ySide: cameraOffMarkerSides.top,
    color: '#00ffff',
    rgb: { r: 0, g: 255, b: 255 },
  },
  {
    id: 'bottom-right',
    xSide: cameraOffMarkerSides.right,
    ySide: cameraOffMarkerSides.bottom,
    color: '#ffff00',
    rgb: { r: 255, g: 255, b: 0 },
  },
  {
    id: 'bottom-left',
    xSide: cameraOffMarkerSides.left,
    ySide: cameraOffMarkerSides.bottom,
    color: '#00ff00',
    rgb: { r: 0, g: 255, b: 0 },
  },
];

export { cameraOffMarkerSides, cameraOffPlaceholderSize, cameraOffMarkerSize, cameraOffMarkers };
